import { NgModule } from '@angular/core';
import { DNGXDigitOnlyDirective } from './digit-only.directive';

@NgModule({
  imports: [],
  declarations: [DNGXDigitOnlyDirective],
  exports: [DNGXDigitOnlyDirective],
})
export class DigitOnlyModule { }
